import { DEFAULT_LABELS_PREDICTION_MARKET } from "@roman/shared/constants/predictionMarket";
import { LEAGUES, type League, SPORTS, type Sport, TABS, type Tab } from "@roman/shared/constants/tournaments";
import {
  type LabelData,
  SortPredictionMarketEnum,
  type SubLabelData,
} from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
export interface IHomePageStore {
  selectedLeague: League;
  setSelectedLeague: (league: League) => void;
  selectedTab: Tab;
  setSelectedTab: (tab: Tab) => void;
  selectedSport: Sport;
  setSelectedSport: (sport: Sport) => void;

  isOpenMyPageSidebar: boolean;
  setIsOpenMyPageSidebar: (isOpen: boolean) => void;

  selectedLabel: LabelData;
  setSelectedLabel: (label: LabelData) => void;
  selectedSubLabel: SubLabelData;
  setSelectedSubLabel: (label: SubLabelData) => void;
  selectedSortPredictionMarketType: SortPredictionMarketEnum;
  setSelectedSortPredictionMarketType: (sortType: SortPredictionMarketEnum) => void;
}

export const useHomePageStore = create<IHomePageStore>((set) => ({
  selectedLeague: LEAGUES[0],
  selectedSport: SPORTS[0],
  isOpenMyPageSidebar: false,
  selectedTab: TABS[0],
  selectedLabel: DEFAULT_LABELS_PREDICTION_MARKET[0],
  selectedSubLabel: { id: "人気-すべて", label: "すべて" },
  selectedSortPredictionMarketType: SortPredictionMarketEnum.Recommended,

  setSelectedLeague: (league: League) => set({ selectedLeague: league }),
  setSelectedSport: (sport: Sport) => set({ selectedSport: sport }),
  setSelectedTab: (tab: Tab) => set({ selectedTab: tab }),
  setIsOpenMyPageSidebar: (isOpen: boolean) => set({ isOpenMyPageSidebar: isOpen }),
  setSelectedLabel: (label: LabelData) => set({ selectedLabel: label }),
  setSelectedSubLabel: (label: SubLabelData) => set({ selectedSubLabel: label }),
  setSelectedSortPredictionMarketType: (sortType: SortPredictionMarketEnum) =>
    set({ selectedSortPredictionMarketType: sortType }),
}));

interface ISkipPrizesStore {
  skipPrizes: boolean;
  setSkipPrizes: (skip: boolean) => void;
}

export const useSkipPrizesStore = create<ISkipPrizesStore>()(
  persist(
    (set) => ({
      skipPrizes: false,
      setSkipPrizes: (skip: boolean) => set({ skipPrizes: skip }),
    }),
    {
      name: "skip-prizes-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
